<template>
  <section class="header-con">
    <div class="header">
      <div class="logo">
        <img :src="img1" alt="掌门1对1">
      </div>
      <div class="tel">
        <div v-if="$route.name =='youke-home' ">
          <span class="header-right-city">上海</span>
          <router-link :to="{name: 'youke-index'}">
            <span style="color: #999">[切换城市]</span>
          </router-link>
        </div>
        <img v-else src="../../assets/image/common/tel@3x.png" alt="掌门1对1">
      </div>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'headerV1',
    props: {
      img1: {
        type: String,
        default: '../../../static/img/logo_new.png'
      }
    }
  }
</script>
<style lang="scss" rel="stylesheet/less" scoped>
  @import "../../styles/mixin.scss";

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: px2rem(10) px2rem(44) 0 px2rem(44);
    height: px2rem(90);
    background: #fff;
    .logo {
      width: px2rem(300);
      img {
        width: 100%;
        /*width: px2rem(255);*/
        /*height: px2rem(44);*/
      }
    }
    .tel {
      img {
        width: px2rem(204);
        height: px2rem(33);
      }
      font-size: px2rem(30);
    }
  }
</style>
